import React, { useState, useEffect, useRef, useCallback  } from 'react';
import Logo from "../images/logo.svg";
import Select from 'react-select';
import Sidebar from '../component/Sidebar';
import { SelectPicker, Placeholder, Message ,Whisper, Tooltip, Popover, Button, Loader  } from 'rsuite';
import 'rsuite/dist/rsuite.min.css';
import { Link, useNavigate } from "react-router-dom";
import 'aos/dist/aos.css';
import AOS from 'aos';
import { Center } from '@chakra-ui/react';
import CheckIcon from '@rsuite/icons/Check';
import CloseIcon from '@rsuite/icons/Close';
import iconFinnhub from "../images/iconFinnhub.svg";
import { motion, AnimatePresence } from 'framer-motion';
import Lottie from "lottie-react";
import animationData1 from '../lottie/1.json';
import animationData2 from '../lottie/2.json';
import animationData3 from '../lottie/3.json';
import animationData4 from '../lottie/4.json';
import animationData5 from '../lottie/5.json';
import animationData6 from '../lottie/6.json';
import { ChakraProvider, useToast, Wrap } from '@chakra-ui/react'

function Test() {
  const [tabName, setTabName] = useState('Test');
  useEffect(() => {
    document.title = tabName;
  }, [tabName]);


  const apiEndPoint = process.env.REACT_APP_API_ENDPOINT;
  const [countryFinnhubCode, setCountryFinnhubCode] = useState("");
  const [currencyFinnhubCode, setCurrencyFinnhubCode] = useState("");

  const [countryData, setCountryData] = useState([]);
  const [finnhubshares, setFinnhubShares] = useState('');
  const [finnhubMarketCap, setFinnhubMarketCap] = useState('');
  const [finnhubisin, setFinnhubIsin] = useState('');
  
  const userid = localStorage.getItem("novauserid");

  const [exchangeData, setExchangeData] = useState([]);
  const [currencyData, setCurrencyData] = useState([]);
  const [fetchCompanySymbol, setFetchCompanySymbol] = useState('');
  const [fetchCompanyExchange, setFetchCompanyExchange] = useState(null)



  //Country List
  useEffect(() => {
    const fetchCountryList = async () => {
      const url = ` ${apiEndPoint}/get_all_country_list`;
      const payload = {
        data: {
          user_id: userid // Replace with the actual user_id if dynamic
        }
      };
  
      try {
        const response = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        });
  
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
  
        const responseData = await response.json();
        const data = responseData.data; // Flatten the response

        const formattedCountryData = data.data.map((country) => ({
          label: country.country_name,
          value: country.country_code,
        }));

        setCountryData(formattedCountryData);
  
      } catch (error) {
        console.log(error);
      }
    };
  
    fetchCountryList();
  }, []);


    //Exchange List
    useEffect(() => {
      const fetchExchangeList = async () => {
        const url = ` ${apiEndPoint}/exchange_symbol_list`;
        const payload = {
          data: {
            user_id: userid // Replace with the actual user_id if dynamic
          }
        };
    
        try {
          const response = await fetch(url, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(payload),
          });
    
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
    
          const responseData = await response.json();
          const data = responseData.data; // Flatten the response
  
          const formattedExchangeData = data.symbols.map((exchange) => ({
            label: exchange.exchange_symbol,
            value: exchange.exchange_symbol,
          }));
          setExchangeData(formattedExchangeData);
        } catch (error) {
          console.log(error);
        }
      };
    
      fetchExchangeList();
    }, []);


      //Currency List 
      useEffect(() => {
        const fetchCurrencyList = async () => {
          const url = ` ${apiEndPoint}/currency_symbol_list`;
          const payload = {
            data: {
              user_id: userid // Replace with the actual user_id if dynamic
            }
          };
      
          try {
            const response = await fetch(url, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(payload),
            });
      
            if (!response.ok) {
              throw new Error('Network response was not ok');
            }
      
            const responseData = await response.json();
            const data = responseData.data; // Flatten the response
    
            const formattedCurrencyData = data.symbols.map((exchange) => ({
              label: exchange.currency,
              value: exchange.currency,
            }));
            setCurrencyData(formattedCurrencyData);
          } catch (error) {
            console.log(error);
          }
        };
      
        fetchCurrencyList();
      }, []);

      

const toast = useToast()
const toastIdRef = React.useRef()

 // FETCH FINNHUB 
 const [failedStep, setFailedStep] = useState(null);
 const [currentStep, setCurrentStep] = useState(-1);
 const [completedSteps, setCompletedSteps] = useState([]);
 const [loading2, setLoading2] = useState(false);
 const [missingFields, setMissingFields] = useState([]);

 const [isPushed, setIsPushed] = useState(false);

 const stepsConfig = [
  {
    label: 'Getting Data from Finnhub',
    // action: async () => {
    //   const response = await fetch(`${apiEndPoint}/addnewcompany_finhub`, {
    //     method: 'POST',
    //     headers: { 'Content-Type': 'application/json' },
    //     body: JSON.stringify({
    //       data: {
    //         user_id: userid,
    //         exchange: fetchCompanyExchange, // dynamic exchange value
    //         company_symbol: fetchCompanySymbol // dynamic company symbol
    //       }
    //     })
    //   });
    //   const result = await response.json();
    //   if (!response.ok || result?.success === false) {
    //     throw new Error(result?.message || 'Failed at step: Getting Data from Finnhub');
    //   }
    // }
    action: async () => {
      // Replace with your next API call
      await new Promise(resolve => setTimeout(resolve, 1000)); // simulate success
    }
  },
  {
    label: 'Storing in the Database',
    action: async () => {
      // Replace with your next API call
      await new Promise(resolve => setTimeout(resolve, 1000)); // simulate success
    }
  },
  {
    label: 'Data Cleaning',
    action: async () => {
      const response = await fetch(`${apiEndPoint}/clean_company_profile`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          data: {
            user_id: userid, // dynamic
            company_symbol: fetchCompanySymbol // dynamic
          }
        })
      });
      const result = await response.json();
      if (!response.ok || result?.success === false) {
        throw new Error(result?.message || 'Failed at step: Data Cleaning');
      }

      if (result?.data?.status === 'warning') {
        setMissingFields(result?.data?.missing_fields || []);
        throw new Error('Some fields are missing');
      }

    }
  },
  {
    label: 'Validating Data...',
    action: async () => {
      await new Promise(resolve => setTimeout(resolve, 1000));
      // Replace with your next API call
      //throw new Error('Validation failed'); // simulate failure
    }
  },
  {
    label: 'Added to Production',
    action: async () => {
      const response = await fetch(`${apiEndPoint}/addtoprod_companyprofile`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          data: {
            company_symbol: fetchCompanySymbol // dynamic
          }
        })
      });
      const result = await response.json();
      if (!response.ok || result?.success === false) {
        throw new Error(result?.message || 'Failed at step: Added to Production');
      }
    }
  },
  {
    label: 'Company Data Successfully Pushed to Typesense',
    action: async () => {
      await new Promise(resolve => setTimeout(resolve, 1000));
      setIsPushed(true); // Set state to true
    }
  }
];


const [currentAnimation, setCurrentAnimation] = useState(animationData1);
const animationMap = [
  animationData1,
  animationData2,
  animationData3,
  animationData4,
  animationData6,
  animationData6
];

const handleFinnhubCountryChange = (value) => {
  setCountryFinnhubCode(value);
};

const handleFinnhubCurrencyChange = (value) => {
  setCurrencyFinnhubCode(value);
};

const handleAdd = async () => {
  let hasError = false;

  if (!fetchCompanySymbol.trim()) {
    toastIdRef.current = toast({
      description: "Company symbol is required",
      status: 'error',
      duration: 5000,
      isClosable: true,
      position: 'bottom',
    });
    hasError = true;
  }

  if (!fetchCompanyExchange) {
    toastIdRef.current = toast({
      description: "Exchange selection is required",
      status: 'error',
      duration: 5000,
      isClosable: true,
      position: 'bottom',
    });
    hasError = true;
  }

  if (hasError) return;

  setLoading2(true);
  setCompletedSteps([]);
  setCurrentStep(0);
  setFailedStep(null);

  for (let i = 0; i < stepsConfig.length; i++) {
    setCurrentStep(i);
    setCurrentAnimation(animationMap[i]);
    
    try {
      await stepsConfig[i].action(); // execute API or step
      setCompletedSteps((prev) => [...prev, i]);
    } catch (error) {
      console.error(`Step "${stepsConfig[i].label}" failed:`, error.message);
      setFailedStep(i);
      setCurrentAnimation(animationData5);
      setLoading2(false);
      return;
    }
  }

  setLoading2(false);
  setCurrentStep(-1);
};


 const renderIcon = (index) => {
   if (failedStep === index) {
     return <CloseIcon style={{ color: '#DA293E', marginRight: '8px', width: 13 }} />;
   } else if (completedSteps.includes(index)) {
     return <CheckIcon style={{ color: '#0A8F43', marginRight: '8px', width: 13 }} />;
   } else if (loading2 && currentStep === index) {
     return <Loader size="xs" style={{ marginRight: '8px', width: 13 }} />;
   } else {
     return (
       <span
         style={{
           width: '8px',
           height: '8px',
           borderRadius: '50%',
           backgroundColor: '#878787',
           marginTop: 5,
           display: 'inline-block',
           marginRight: '10px'
         }}
       />
     );
   }
 };

 const [showTooltip, setShowTooltip] = useState(window.innerWidth < 1500);

 useEffect(() => {
   const handleResize = () => {
     setShowTooltip(window.innerWidth < 1500);
   };

   window.addEventListener('resize', handleResize);
   return () => window.removeEventListener('resize', handleResize);
 }, []);


 const handleClose = () => {
  // Set the isPushed flag to true when the button is clicked
  setIsPushed(false);
  setCurrentAnimation(animationData1);
  setFetchCompanySymbol('');
  setFetchCompanyExchange('');
  setCompletedSteps([]);
  const cancelButton = document.getElementById(`hiddenFinnhubClose`);
  if (cancelButton) {
    cancelButton.click();
  }

};

const handleRetry = () => {

  let hasError = false;

  if (missingFields.includes('currency')) {
    if (!currencyFinnhubCode) {
            toastIdRef.current = toast({ description: 'Please Select Currency', status: 'error', duration: 5000, isClosable: true, position: 'bottom-left', });
            hasError = true;
        }
  }

  if (missingFields.includes('country')) {
    if (!countryFinnhubCode) {
            toastIdRef.current = toast({ description: 'Please Select Country', status: 'error', duration: 5000, isClosable: true, position: 'bottom-left', });
            hasError = true;
        }
  }

  if (missingFields.includes('shareOutstanding')) {
    if (!finnhubshares) {
            toastIdRef.current = toast({ description: 'Please Add Share Outstanding', status: 'error', duration: 5000, isClosable: true, position: 'bottom-left', });
            hasError = true;
        }
  }

  if (missingFields.includes('marketCapitalization')) {
    if (!finnhubMarketCap) {
            toastIdRef.current = toast({ description: 'Please Add Market Cap', status: 'error', duration: 5000, isClosable: true, position: 'bottom-left', });
            hasError = true;
        }
  }

  if (missingFields.includes('isin')) {
    if (!finnhubisin) {
            toastIdRef.current = toast({ description: 'Please Add ISIN', status: 'error', duration: 5000, isClosable: true, position: 'bottom-left', });
            hasError = true;
        }
  }



  if (!hasError) {
  }


};

  return (
    <>
      <Sidebar />
      <div id='header'>
        <div className='logo'>
          <div className='logo_icon'>
            <img src={Logo} alt="Logo" />
          </div>
          <div className='brand_name'>Company Profile</div>
        </div>

      
        <div className='header_monthly_value btn__group_header'>
          <Whisper
            placement="left"
            trigger="hover"
            speaker={showTooltip ? <Tooltip>Fetch from Finnhub</Tooltip> : <span />}
          >
            <button
              type="button"
              className="btn__fetch_finnhub"
              data-bs-toggle="modal"
              data-bs-target="#ModalFinnhub"
            >
              <img src={iconFinnhub} alt="Finnhub Icon" />
              <span>Fetch from Finnhub</span>
            </button>
          </Whisper>

        </div>
      </div>
     

      <div class="modal fade modal_finnhub_fetch" id="ModalFinnhub" tabindex="-1" aria-labelledby="AddNewAnalystModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <div>
                <h5>Fetch Company Data from Finnhub</h5>
                <p>Enter the Company Symbol to fetch and process data</p>
              </div>
            </div>
            <div class="modal-body finnhub_fetch_body">
              <div className='finnhub_fetch_row'>
                <div className='finnhub_fetch_col'>
                  <label>Enter Company Symbol<span className='star_red'>*</span></label>
                  <input type='text' className='form-control' placeholder='Enter the company symbol manually'  value={fetchCompanySymbol}
        onChange={(e) => setFetchCompanySymbol(e.target.value)} />
                </div>
                <div className='finnhub_fetch_col2'>
                  <label>Enter Exchange<span className='star_red'>*</span></label>
                  <div className='select_drop_picker'>
                    <SelectPicker
                      data={exchangeData}
                      searchable={false}
                      style={{ width: '100%' }}
                      placeholder="Select the Exchange"
                      value={fetchCompanyExchange}
                      onChange={(value) => setFetchCompanyExchange(value)}
                    />
                  </div>
                </div>
<ChakraProvider>
  <Wrap>
                <Button className='btn__fetch_add' onClick={handleAdd}><i className='icon-plus'></i> Add</Button>
                </Wrap>
</ChakraProvider>
              </div>
              <div className='finnhub_animation_section'>
                <ul className="finnhub_anim_list">
                {stepsConfig.map((step, index) => {
  const isFailed = failedStep === index;
  const isCompleted = completedSteps.includes(index);

  return (
    <li key={index} style={{
      display: 'flex',
      alignItems: 'flex-start',
      marginBottom: '8px',
      color: isFailed ? '#DA293E' : isCompleted ? '#0A8F43' : '#696969'
    }}>
      {renderIcon(index)}
      <span>{step.label}</span>
    </li>
  );
})}
                </ul>

                <div className='icon_finnhub_col'>
                <Lottie animationData={currentAnimation} loop autoplay />
                </div>
              </div>

              <AnimatePresence>
                {failedStep !== null && (
                  <motion.div className='finnhub_invalid_form_row' initial={{ opacity: 0, y: -50, height: 0 }} animate={{ opacity: 1, y: 0, height: 'auto' }} exit={{ opacity: 0, y: -50, height: 0 }} transition={{ duration: 0.7, ease: 'easeInOut' }} style={{ flexWrap: 'wrap' }}>
                    {missingFields.includes('currency') && (
                    <div className='finnhub_fetch_col2' style={{ width: 'calc(33.33% - 18px)' }}>
                      <label>Currency<span className='star_red'>*</span></label>
                      <div className='select_drop_picker clsFinhubbDdl'>
                      <SelectPicker
                            data={currencyData}
                            searchable={false}
                            style={{width:'100%'}}
                            placeholder="Select Currency"
                            onChange={handleFinnhubCurrencyChange}
                            value={currencyFinnhubCode}
                          />
                  </div>
                    </div>
                    )}

                     {missingFields.includes('country') && (
                    <div className='finnhub_fetch_col2' style={{ width: 'calc(33.33% - 18px)' }}>
                  <label>Country<span className='star_red'>*</span></label>
                  <div className='select_drop_picker clsFinhubbDdl'>
                  <SelectPicker
                        data={countryData}
                        searchable={false}
                        style={{width:'100%'}}
                        placeholder="Select Country"
                        onChange={handleFinnhubCountryChange}
                        value={countryFinnhubCode}
                      />
                  </div>
                   </div>
                      )}

                    {missingFields.includes('shareOutstanding') && (

                    <div className='finnhub_invalid_form_col' style={{ width: 'calc(33.33% - 18px)' }}>
                      <label>Shares Outstanding<span className='star_red'>*</span></label>
                      <input type='text' className='form-control' placeholder='Enter Shares Outstanding'    value={finnhubshares}
      onChange={(e) =>
        setFinnhubShares(
          e.target.value
            .replace(/[^0-9.]/g, '')        // Remove anything other than digits and .
            .replace(/(\..*?)\..*/g, '$1')  // Allow only one .
        )
      }/>
                    </div>
                       )}

{missingFields.includes('marketCapitalization') && (
                    <div className='finnhub_invalid_form_col' style={{ width: 'calc(33.33% - 18px)' }}>
                      <label>Market Cap<span className='star_red'>*</span></label>
                      <input type='text' className='form-control' placeholder='Enter Market Cap' value={finnhubMarketCap}
      onChange={(e) =>
        setFinnhubMarketCap(
          e.target.value
            .replace(/[^0-9.]/g, '')        // Remove anything other than digits and .
            .replace(/(\..*?)\..*/g, '$1')  // Allow only one .
        )}/>
                    </div>
)}


{missingFields.includes('isin') && (

                    <div className='finnhub_invalid_form_col' style={{ width: 'calc(33.33% - 18px)' }}>
                      <label>ISIN<span className='star_red'>*</span></label>
                      <input type='text' className='form-control' placeholder='Enter ISIN'  value={finnhubisin}
      onChange={(e) =>
        setFinnhubIsin(e.target.value.replace(/[^a-zA-Z0-9]/g, '')) // Allow only letters and numbers
      } />
                    </div>
)}
                  </motion.div>
                )}
              </AnimatePresence>



            
              <div class="btn__group mt-5" style={{}}>
              {missingFields.length > 0 && (
                <>
                <Button type="button" className="btn_cancel" id="CancelDelete" data-bs-dismiss="modal">Cancel</Button>
                <Button className="btn_delete" onClick={handleRetry}>Retry</Button>
                </>
              )}

              {isPushed && (
                <>
                 <Button type="button" className="btn_cancel hidden" id="hiddenFinnhubClose" data-bs-dismiss="modal" >Cancel</Button>
                 <Button type="button" className="btn_cancel" id="ClosePopup"  onClick={handleClose}>Close</Button>
                 </>
              )}
              


              </div>
           
            </div>

          </div>
        </div>
      </div>


    </>
  );
}

export default Test;
